<template>
    <div class="container">
        <div class=" mt-xl-5 mb-xl-5 pb-xl-3 mb-2 mt-3 pb-2 pt-1 text-xl-left text-center">
            <h2 class="font-glacial-bold font-70">
                {{data.titulo}}
            </h2>
        </div>
        <div class="row justify-content-between mb-xl-3 mb-0 pb-2">
            <div class="col-xl-5" v-for="(d, index) in data.datas" :key="index">
                <b-media>
                    <p slot="aside" class="font-regular" :style="`font-size: 36px; color: #ffb09f`">
                        <strong>{{d.ano}}</strong>
                    </p>
                    <div class="font-glacial-bold mt-1" :style="`font-size: 18px;`">
                        <h1 class="font-glacial-bold font-18 text-uppercase">
                            {{data.titulo}}
                        </h1>
                    </div>
                    <div class="font-glacial-regular text-gray mb-5 pb-2">
                        {{d.descricao}}
                    </div>
                    
                </b-media>
                    
            </div>
        </div>
        
    </div>
</template>

<script>
    export default {
        props:{
            data: null
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/widgets/ano_descricao.vue